import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Users, Stethoscope, CalendarDays, ClipboardCheck } from "lucide-react";
import { StatCard, PageLoading } from "@dosa/ui";
import { getBusinessKpis } from "../../lib/api-client";

export function AdminDashboardPage() {
  const { t } = useTranslation();
  const { data: kpis, isLoading } = useQuery({ queryKey: ["business-kpis"], queryFn: getBusinessKpis });

  if (isLoading || !kpis) return <PageLoading />;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.dashboard.title")}</h1>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label={t("admin.kpis.totalPatients")} value={kpis.totalPatients} icon={<Users className="h-5 w-5" />} />
        <StatCard label={t("admin.kpis.totalPharmacists")} value={kpis.totalPharmacists} icon={<Stethoscope className="h-5 w-5" />} />
        <StatCard label={t("admin.kpis.appointmentsThisMonth")} value={kpis.appointmentsThisMonth} icon={<CalendarDays className="h-5 w-5" />} />
        <StatCard label={t("admin.kpis.completedAssessments")} value={kpis.completedMtmAssessmentsThisMonth} icon={<ClipboardCheck className="h-5 w-5" />} />
      </div>
    </div>
  );
}
